
export const WORKOUT_DATA = [

  {
    id: 2,
    name: 'Lower Body & Core',
    exercises_count: 4,
    premium: false,
    image: 'https://images.unsplash.com/photo-1434608519344-49d77a699e1d?w=800',
    exercises: [
      { id: 'lb1', name: 'Barbell Squat', sets: 4, reps: 12, videoPath: 'Hips/Classic Barbell Squat.mp4', muscles: ['Quads', 'Glutes'], steps: ['Bar on traps', 'Squat deep', 'Drive through heels'] },
      { id: 'lb2', name: 'Deadlifts', sets: 4, reps: 10, videoPath: 'back/Barbell Straight Leg Deadlift.mp4', muscles: ['Hamstrings', 'Back'], steps: ['Hinge at hips', 'Keep back flat', 'Lower bar to shins'] },
      { id: 'lb3', name: 'Leg Press', sets: 3, reps: 12, videoPath: 'Hips/Close Feet Leg Press.mp4', muscles: ['Quads'], steps: ['Sit in machine', 'Push platform', 'Lower slowly'] },
      { id: 'lb4', name: 'Twisting Crunch', sets: 3, reps: 20, videoPath: 'abs/Twisting Crunch.mp4', muscles: ['Abs', 'Obliques'], steps: ['Lie on back', 'Crunch up', 'Twist elbow to knee'] },
   
    ]
  },
  {
    id: 3, // Unique ID for this workout plan
    name: 'Forearm Strength & Mobility',
    exercises_count: 8,
    premium: false,
    image: 'https://plus.unsplash.com/premium_photo-1661265933107-85a5dbd815af?w=800',
    exercises: [
      { 
        id: 'fa1', 
        name: 'Barbell Reverse Wrist Curl (over-grip)', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Forearms/Barbell Reverse Wrist Curl (over-grip).mp4', 
        muscles: ['Forearms', 'Extensors'], 
        steps: ['Grasp barbell with overhand grip', 'Rest forearms on bench', 'Curl wrists upward', 'Lower under control'] 
      },
      { 
        id: 'fa2', 
        name: 'Barbell Standing Back Wrist Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Forearms/Barbell Standing Back Wrist Curl.mp4', 
        muscles: ['Forearms'], 
        steps: ['Hold barbell behind your back', 'Use a shoulder-width grip', 'Curl the bar up with your wrists', 'Hold briefly at the top'] 
      },
      { 
        id: 'fa3', 
        name: 'Dumbbell Behind Back Wrist Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Forearms/Dumbbell Behind Back Wrist Curl.mp4', 
        muscles: ['Forearms', 'Flexors'], 
        steps: ['Hold dumbbells behind your glutes', 'Keep arms straight', 'Curl weights up toward lower back', 'Lower slowly'] 
      },
      { 
        id: 'fa4', 
        name: 'Dumbbell Over Bench Wrist Curl', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Forearms/Dumbbell Over Bench Wrist Curl.mp4', 
        muscles: ['Forearms'], 
        steps: ['Rest forearms on a flat bench', 'Hands hanging over the edge', 'Curl dumbbells toward the ceiling', 'Slowly extend back down'] 
      },
      { 
        id: 'fa5', 
        name: 'Dumbbell Seated Neutral Wrist Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Forearms/Dumbbell Seated Neutral Wrist Curl.mp4', 
        muscles: ['Forearms', 'Brachioradialis'], 
        steps: ['Sit and rest forearms on thighs', 'Hold dumbbells with neutral (hammer) grip', 'Curl wrists up and down', 'Maintain controlled motion'] 
      },
      { 
        id: 'fa6', 
        name: 'Stretching - Side Wrist Pull Stretch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Forearms/Stretching - Side Wrist Pull Stretch.mp4', 
        muscles: ['Wrist Extensors'], 
        steps: ['Extend one arm forward', 'Pull fingers gently to the side/down', 'Hold for 30 seconds', 'Repeat on opposite arm'] 
      },
      { 
        id: 'fa7', 
        name: 'Stretching - Wrist Circles', 
        sets: 2, 
        reps: 20, 
        videoPath: 'Forearms/Stretching - Wrist Circles.mp4', 
        muscles: ['Wrist Joints'], 
        steps: ['Clasp hands together', 'Rotate wrists in a circular motion', 'Switch directions halfway through', 'Keep shoulders relaxed'] 
      },
      { 
        id: 'fa8', 
        name: 'Weighted Standing Curl', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Forearms/Weighted Standing Curl.mp4', 
        muscles: ['Forearms', 'Biceps'], 
        steps: ['Stand with feet shoulder-width', 'Hold weight with palms up', 'Curl toward chest', 'Squeeze forearms at the top'] 
      }
    ]
  },
  {
    id: 4,
    name: 'Advanced Hips & Glutes',
    exercises_count: 21, // Total count from your IDs 9 to 29
    premium: false,
    image: 'https://plus.unsplash.com/premium_photo-1661582170363-0a42b3f5e3cb?w=800', // Matches your "Lower Body" style
    exercises: [
      { 
        id: 'hp9', 
        name: 'Lever Standing Hip Extension', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Hips/Lever Standing Hip Extension.mp4', 
        muscles: ['Hips', 'Glutes'], 
        steps: ['Adjust lever height', 'Stand with one leg against pad', 'Extend hip backward', 'Control return'] 
      },
      { 
        id: 'hp12', 
        name: 'Sled 45 Degree Leg Wide Press', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Hips/Sled 45 Degree Leg Wide Press.mp4', 
        muscles: ['Hips', 'Quads', 'Adductors'], 
        steps: ['Place feet wide on platform', 'Lower sled toward chest', 'Push up through heels', 'Do not lock knees'] 
      },
      { 
        id: 'hp15', 
        name: 'Smith Leg Press', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Hips/Smith Leg Press.mp4', 
        muscles: ['Hips', 'Quads'], 
        steps: ['Lie under Smith bar', 'Place feet on bar securely', 'Unlatch and lower bar', 'Press upward'] 
      },
      { 
        id: 'hp16', 
        name: 'Squat', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Hips/Squat.mp4', 
        muscles: ['Hips', 'Glutes', 'Quads'], 
        steps: ['Feet shoulder-width apart', 'Lower hips until parallel', 'Maintain flat back', 'Drive upward through heels'] 
      },
      { 
        id: 'hp17', 
        name: 'Stretching - Adductor stretch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Hips/Stretching - Adductor stretch.mp4', 
        muscles: ['Inner Thighs', 'Hips'], 
        steps: ['Stand with wide stance', 'Lean to one side', 'Feel stretch in opposite inner thigh', 'Hold for 30 seconds'] 
      },
      { 
        id: 'hp23', 
        name: 'Stretching - Hip Circles Stretch', 
        sets: 2, 
        reps: 15, 
        videoPath: 'Hips/Stretching - Hip Circles Stretch.mp4', 
        muscles: ['Hip Joints'], 
        steps: ['Stand with hands on hips', 'Rotate hips in wide circles', 'Switch directions', 'Keep core stable'] 
      },
      { 
        id: 'hp27', 
        name: 'Stretching - Knee Raise', 
        sets: 2, 
        reps: 12, 
        videoPath: 'Hips/Stretching - Knee Raise.mp4', 
        muscles: ['Hips', 'Lower Back'], 
        steps: ['Stand straight', 'Pull one knee toward chest', 'Hold briefly', 'Lower and switch legs'] 
      }
    ]
  },
{
    id: 5,
    name: 'Shoulder Power & Mobility',
    exercises_count: 22, // Based on the range IDs 55–76 in your database
    premium: false,
    image: 'https://images.unsplash.com/photo-1532384661798-58b53a4fbe37?w=800', 
    exercises: [
      { 
        id: 'sh55', 
        name: 'Dumbbell Alternate Shoulder Press', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Shoulders/Dumbbell Alternate Shoulder Press.mp4', 
        muscles: ['Shoulders', 'Triceps'], 
        steps: ['Hold dumbbells at shoulder height', 'Press one arm up while keeping the other stable', 'Lower and switch arms'] 
      },
      { 
        id: 'sh56', 
        name: 'Dumbbell Arnold Press', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Shoulders/Dumbbell Arnold Press.mp4', 
        muscles: ['Shoulders'], 
        steps: ['Start with palms facing you', 'Rotate wrists as you press upward', 'Finish with palms facing forward'] 
      },
      { 
        id: 'sh62', 
        name: 'Dumbbell Lateral Raise', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Shoulders/Dumbbell Lateral Raise.mp4', 
        muscles: ['Lateral Deltoids'], 
        steps: ['Hold weights at sides', 'Raise arms out to the sides with a slight bend in elbows', 'Lower slowly to start position'] 
      },
      { 
        id: 'sh64', 
        name: 'Dumbbell Rear Delt Row', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Shoulders/Dumbbell Rear Delt Row.mp4', 
        muscles: ['Rear Deltoids', 'Upper Back'], 
        steps: ['Hinge at hips with flat back', 'Pull dumbbells toward chest with elbows wide', 'Squeeze shoulder blades at the top'] 
      },
      { 
        id: 'sh71', 
        name: 'Lever Military Press', 
        sets: 4, 
        reps: 8, 
        videoPath: 'Shoulders/Lever Military Press.mp4', 
        muscles: ['Shoulders'], 
        steps: ['Sit or stand at the machine', 'Grip handles and press upward fully', 'Lower under control to ear level'] 
      },
      { 
        id: 'sh75', 
        name: 'Stretching - Band Warm-up Shoulder Stretch', 
        sets: 2, 
        reps: 12, 
        videoPath: 'Shoulders/Stretching - Band Warm-up Shoulder Stretch.mp4', 
        muscles: ['Shoulder Joint'], 
        steps: ['Hold resistance band with wide grip', 'Keep arms straight and rotate them behind your head', 'Return to front slowly'] 
      },
      { 
        id: 'sh76', 
        name: 'Stretching - Rear Deltoid Stretch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Shoulders/Stretching - Rear Deltoid Stretch.mp4', 
        muscles: ['Rear Deltoids'], 
        steps: ['Pull one arm across your chest', 'Use the other arm to deepen the stretch', 'Hold for 30 seconds and switch'] 
      }
    ]
  },

  {
    id: 6,
    name: 'Triceps Definition & Strength',
    exercises_count: 19, // Based on the range IDs 120–138 in your database
    premium: false,
    image: 'https://i0.wp.com/www.muscleandfitness.com/wp-content/uploads/2024/08/Man-with-muscular-triceps-after-performing-effective-triceps-exercises-.jpg?quality=86&strip=all', 
    exercises: [
      { 
        id: 'tr120', 
        name: 'Band Overhead Triceps Extension', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Triceps/Band Overhead Triceps Extension.mp4', 
        muscles: ['Triceps'], 
        steps: ['Secure resistance band under feet', 'Pull band overhead with both hands', 'Extend arms fully upward', 'Lower slowly behind head'] 
      },
      { 
        id: 'tr123', 
        name: 'Barbell Close Grip Bench Press', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Triceps/Barbell Close Grip Bench Press.mp4', 
        muscles: ['Triceps', 'Inner Chest'], 
        steps: ['Lie on bench with narrow grip on bar', 'Lower bar to mid-chest', 'Keep elbows tucked to sides', 'Press bar back to starting position'] 
      },
      { 
        id: 'tr124', 
        name: 'Bench Dips', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Triceps/Bench Dips.mp4', 
        muscles: ['Triceps'], 
        steps: ['Place hands on edge of bench behind you', 'Extend legs forward', 'Lower hips by bending elbows', 'Push back up to full extension'] 
      },
      { 
        id: 'tr127', 
        name: 'Cable Pushdown (rope attachment)', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Triceps/Cable Pushdown (rope attachment).mp4', 
        muscles: ['Triceps'], 
        steps: ['Grip rope attachment with palms facing in', 'Keep elbows fixed at your sides', 'Push hands down until arms are straight', 'Squeeze triceps at the bottom'] 
      },
      { 
        id: 'tr131', 
        name: 'Close Grip Push-ups', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Triceps/Close Grip Push-ups.mp4', 
        muscles: ['Triceps', 'Chest'], 
        steps: ['Place hands closer than shoulder width', 'Keep body in a straight line', 'Lower chest toward floor', 'Push back up explosively'] 
      },
      { 
        id: 'tr134', 
        name: 'Dumbbell Kickback', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Triceps/Dumbbell Kickback.mp4', 
        muscles: ['Triceps'], 
        steps: ['Hinge at hips with one hand on a bench', 'Keep upper arm parallel to floor', 'Extend dumbbell backward until arm is straight', 'Return to starting position under control'] 
      },
      { 
        id: 'tr136', 
        name: 'Dumbbell Lying Triceps Extension', 
        sets: 3, 
        reps: 10, 
        videoPath: 'Triceps/Dumbbell Lying Triceps Extension.mp4', 
        muscles: ['Triceps'], 
        steps: ['Lie on bench holding dumbbells upward', 'Lower weights toward your ears by bending elbows', 'Keep upper arms stationary', 'Extend weights back to the ceiling'] 
      }
    ]
  },

  {
    id: 7,
    name: 'Core Strength & Sculpt',
    exercises_count: 22, // Based on the range IDs 149–170 in your database
    premium: true,
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800', 
    exercises: [
      { 
        id: 'ab149', 
        name: '45 Degree Side Bend', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Abs/45 Degree Side Bend.mp4', 
        muscles: ['Obliques'], 
        steps: ['Position yourself on a side bend bench', 'Lower your torso sideways', 'Contract obliques to return to start', 'Switch sides'] 
      },
      { 
        id: 'ab150', 
        name: 'Air Twisting Crunch', 
        sets: 3, 
        reps: 20, 
        videoPath: 'Abs/Air Twisting Crunch.mp4', 
        muscles: ['Abs', 'Obliques'], 
        steps: ['Lie on your back with legs in the air', 'Place hands behind head', 'Crunch up and twist elbow toward opposite knee', 'Alternate sides'] 
      },
      { 
        id: 'ab158', 
        name: 'Cable Kneeling Crunch', 
        sets: 4, 
        reps: 15, 
        videoPath: 'Abs/Cable Kneeling Crunch.mp4', 
        muscles: ['Upper Abs'], 
        steps: ['Kneel below a high pulley with rope attachment', 'Grip rope and place hands near ears', 'Flex hips and crunch downward', 'Squeeze abs at the bottom'] 
      },
      { 
        id: 'ab162', 
        name: 'Crunch (on bench)', 
        sets: 3, 
        reps: 20, 
        videoPath: 'Abs/Crunch (on bench).mp4', 
        muscles: ['Abs'], 
        steps: ['Lie on a flat bench with feet flat', 'Place hands behind head or on chest', 'Curl shoulders toward hips', 'Lower under control'] 
      },
      { 
        id: 'ab164', 
        name: 'Hanging Leg Hip Raise', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Abs/Hanging Leg Hip Raise.mp4', 
        muscles: ['Lower Abs', 'Hip Flexors'], 
        steps: ['Hang from a pull-up bar with straight arms', 'Raise legs by flexing hips until parallel to floor', 'Roll pelvis upward at the top', 'Lower slowly'] 
      },
      { 
        id: 'ab167', 
        name: 'Landmine 180', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Abs/Landmine 180.mp4', 
        muscles: ['Core', 'Obliques'], 
        steps: ['Grip the end of a landmine barbell with both hands', 'Pivot feet and rotate the bar in a semi-circle', 'Maintain straight arms', 'Control the weight throughout the arc'] 
      },
      { 
        id: 'ab170', 
        name: 'Lying Floor Leg Raise', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Abs/Lying Floor Leg Raise.mp4', 
        muscles: ['Lower Abs'], 
        steps: ['Lie flat on your back', 'Keep legs straight and raise them to 90 degrees', 'Lower slowly without touching the floor', 'Keep lower back pressed against the ground'] 
      }
    ]
  },
{
    id: 8,
    name: 'V-Taper & Back Strength',
    exercises_count: 15, // Based on the range IDs 186–200 in your database
    premium: true,
    image: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=800', 
    exercises: [
      { 
        id: 'bk186', 
        name: '45 Degree Hyperextension', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Back/45 Degree Hyperextension.mp4', 
        muscles: ['Lower Back', 'Erector Spinae'], 
        steps: ['Position hips on the pad', 'Lower your torso slowly', 'Raise back up until your body is straight', 'Squeeze at the top'] 
      },
      { 
        id: 'bk192', 
        name: 'Barbell Bent-over Row Overgrip', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Back/Barbell Bent-over Row Overgrip.mp4', 
        muscles: ['Lats', 'Middle Back'], 
        steps: ['Hinge at hips with a flat back', 'Grip bar with palms down', 'Pull bar toward lower chest', 'Lower under control'] 
      },
      { 
        id: 'bk193', 
        name: 'Barbell Straight Leg Deadlift', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Back/Barbell Straight Leg Deadlift.mp4', 
        muscles: ['Lower Back', 'Hamstrings'], 
        steps: ['Hold bar with overhand grip', 'Lower bar by hinging at hips with straight legs', 'Keep bar close to shins', 'Return to upright position'] 
      },
      { 
        id: 'bk195', 
        name: 'Bench Pull-ups', 
        sets: 3, 
        reps: 10, 
        videoPath: 'Back/Bench Pull-ups.mp4', 
        muscles: ['Lats', 'Upper Back'], 
        steps: ['Grip pull-up bar wide', 'Use bench for assistance if needed', 'Pull chest toward the bar', 'Lower slowly to full extension'] 
      },
      { 
        id: 'bk196', 
        name: 'Cable Bar Lateral Pulldown (wide shoulder grip)', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Back/Cable Bar Lateral Pulldown (wide shoulder grip).mp4', 
        muscles: ['Lats'], 
        steps: ['Grip wide bar with palms forward', 'Pull bar down to upper chest', 'Keep elbows pointed down', 'Slowly return bar upward'] 
      },
      { 
        id: 'bk199', 
        name: 'Cable Pulldown', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Back/Cable Pulldown.mp4', 
        muscles: ['Lats', 'Biceps'], 
        steps: ['Sit at pulldown station', 'Pull weight toward chest while leaning back slightly', 'Squeeze shoulder blades', 'Control the weight on return'] 
      },
      { 
        id: 'bk200', 
        name: 'Cable Seated High Row (V-bar)', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Back/Cable Seated High Row (V-bar).mp4', 
        muscles: ['Middle Back', 'Rhomboids'], 
        steps: ['Sit and place feet on supports', 'Grip V-bar and pull toward abdomen', 'Squeeze shoulder blades together', 'Extend arms fully back'] 
      }
    ]
  },
{
    id: 9,
    name: 'Bicep Peak & Arm Mass',
    exercises_count: 20, // Based on the range IDs 252–271 in your database
    premium: true,
    image: 'https://www.kettlebellkings.com/cdn/shop/articles/5081e8032e8756f5af10b4fe889693b4.jpg?v=1702645124', 
    exercises: [
      { 
        id: 'bi252', 
        name: 'Barbell Drag Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Biceps/Barbell Drag Curl.mp4', 
        muscles: ['Biceps'], 
        steps: ['Hold barbell with shoulder-width grip', 'Pull bar straight up along your torso', 'Keep elbows back behind the body', 'Squeeze at the top and lower slowly'] 
      },
      { 
        id: 'bi256', 
        name: 'Dumbbell Alternate Biceps Curl', 
        sets: 3, 
        reps: 10, // per arm
        videoPath: 'Biceps/Dumbbell Alternate Biceps Curl.mp4', 
        muscles: ['Biceps', 'Brachialis'], 
        steps: ['Stand with dumbbells at sides', 'Curl one weight toward shoulder while rotating palm up', 'Lower slowly and repeat with opposite arm'] 
      },
      { 
        id: 'bi258', 
        name: 'Dumbbell Biceps Curl', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Biceps/Dumbbell Biceps Curl.mp4', 
        muscles: ['Biceps'], 
        steps: ['Curl both dumbbells simultaneously', 'Keep elbows tucked to your ribs', 'Avoid swinging your body', 'Focus on the contraction at the top'] 
      },
      { 
        id: 'bi259', 
        name: 'Dumbbell Concentration Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Biceps/Dumbbell Concentration Curl.mp4', 
        muscles: ['Biceps Peak'], 
        steps: ['Sit on bench and lean forward', 'Brace elbow against inner thigh', 'Curl weight toward your face', 'Squeeze the bicep hard at the peak'] 
      },
      { 
        id: 'bi260', 
        name: 'Dumbbell Cross Body Hammer Curl', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Biceps/Dumbbell Cross Body Hammer Curl.mp4', 
        muscles: ['Brachialis', 'Forearms'], 
        steps: ['Hold dumbbells with neutral grip', 'Curl one weight across your chest toward the opposite shoulder', 'Maintain neutral grip throughout'] 
      },
      { 
        id: 'bi268', 
        name: 'EZ Barbell Biceps Curl', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Biceps/EZ Barbell Biceps Curl.mp4', 
        muscles: ['Biceps', 'Forearms'], 
        steps: ['Grip the angled parts of the EZ bar', 'Curl the bar toward your shoulders', 'Lower under full control to avoid elbow strain'] 
      },
      { 
        id: 'bi271', 
        name: 'Stretching - Butterfly Yoga Pose', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Biceps/Stretching - Butterfly Yoga Pose.mp4', 
        muscles: ['Biceps', 'Shoulders'], 
        steps: ['Extend arms behind you with palms facing away', 'Interlace fingers and lift arms slightly', 'Feel the stretch through the biceps and chest'] 
      }
    ]
  },
  {
    id: 10,
    name: 'High-Intensity Cardio & Recovery',
    exercises_count: 17, // Based on the range IDs 284–300 in your database
    premium: true,
    image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800', 
    exercises: [
      { 
        id: 'ca284', 
        name: 'Battling Ropes', 
        sets: 3, 
        reps: 30, // seconds
        videoPath: 'Cardio/Battling Ropes.mp4', 
        muscles: ['Full Body', 'Cardio'], 
        steps: ['Stand with feet shoulder-width apart', 'Grip ends of ropes', 'Create waves by alternating arms rapidly', 'Maintain a slight squat position'] 
      },
      { 
        id: 'ca285', 
        name: 'Burpee', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Cardio/Burpee.mp4', 
        muscles: ['Full Body', 'Cardio'], 
        steps: ['Drop into a squat', 'Kick feet back into a plank', 'Perform a push-up', 'Jump back to squat and leap upward'] 
      },
      { 
        id: 'ca289', 
        name: 'Jump Rope', 
        sets: 3, 
        reps: 60, // seconds
        videoPath: 'Cardio/Jump Rope.mp4', 
        muscles: ['Calves', 'Cardio'], 
        steps: ['Hold handles with elbows near ribs', 'Rotate wrists to swing rope', 'Jump slightly to clear the rope', 'Land softly on the balls of your feet'] 
      },
      { 
        id: 'ca291', 
        name: 'Jumping Jack', 
        sets: 3, 
        reps: 20, 
        videoPath: 'Cardio/Jumping Jack.mp4', 
        muscles: ['Full Body', 'Cardio'], 
        steps: ['Start with feet together and arms at sides', 'Jump up and spread feet while clapping hands overhead', 'Jump again to return to starting position'] 
      },
      { 
        id: 'ca292', 
        name: 'Running', 
        sets: 1, 
        reps: 15, // minutes
        videoPath: 'Cardio/Running.mp4', 
        muscles: ['Legs', 'Cardio'], 
        steps: ['Maintain an upright posture', 'Land mid-foot', 'Swing arms naturally', 'Maintain a steady breathing rhythm'] 
      },
      { 
        id: 'ca293', 
        name: 'Stationary Bike', 
        sets: 1, 
        reps: 10, // minutes
        videoPath: 'Cardio/Stationary Bike.mp4', 
        muscles: ['Quads', 'Cardio'], 
        steps: ['Adjust seat to hip height', 'Keep core engaged', 'Pedal at a consistent resistance', 'Keep hands light on the handlebars'] 
      },
      { 
        id: 'ca297', 
        name: 'Stretching - Front Toe Touch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Cardio/Stretching - Front Toe Touch.mp4', 
        muscles: ['Hamstrings', 'Lower Back'], 
        steps: ['Stand with feet together', 'Slowly hinge at the hips', 'Reach toward your toes without bouncing', 'Hold the stretch and breathe deeply'] 
      }
    ]
  },
  {
    id: 11,
    name: 'Calf Strength & Ankle Mobility',
    exercises_count: 12, // Based on range IDs 272–283 in your database
    premium: true,
    image: 'https://images.unsplash.com/photo-1590556409324-aa1d726e5c3c?w=800', 
    exercises: [
      { 
        id: 'cl272', 
        name: 'Dumbbell Single Leg Calf Raise', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Calves/Dumbbell Single Leg Calf Raise.mp4', 
        muscles: ['Gastrocnemius'], 
        steps: ['Stand on one leg holding a dumbbell', 'Raise your heel as high as possible', 'Lower slowly to feel a stretch', 'Switch legs after the set'] 
      },
      { 
        id: 'cl273', 
        name: 'Dumbbell Standing Calf Raise', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Calves/Dumbbell Standing Calf Raise.mp4', 
        muscles: ['Calves'], 
        steps: ['Hold dumbbells at your sides', 'Rise onto the balls of your feet', 'Squeeze at the top', 'Lower under control'] 
      },
      { 
        id: 'cl274', 
        name: 'Lever Standing Calf Raise', 
        sets: 4, 
        reps: 12, 
        videoPath: 'Calves/Lever Standing Calf Raise.mp4', 
        muscles: ['Calves'], 
        steps: ['Position shoulders under the pads', 'Stand on the platform with heels hanging off', 'Push upward through your toes', 'Lower your heels below the platform level'] 
      },
      { 
        id: 'cl275', 
        name: 'Sled 45 Degree Calf Press', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Calves/Sled 45 Degree Calf Press.mp4', 
        muscles: ['Soleus', 'Gastrocnemius'], 
        steps: ['Sit in the leg press machine', 'Place the balls of your feet on the lower edge of the platform', 'Press the platform away using only your ankles', 'Return slowly'] 
      },
      { 
        id: 'cl277', 
        name: 'Stretching - Circles Knee Stretch', 
        sets: 2, 
        reps: 15, 
        videoPath: 'Calves/Stretching - Circles Knee Stretch.mp4', 
        muscles: ['Ankles', 'Calves'], 
        steps: ['Stand with feet together and hands on knees', 'Rotate knees in a circular motion', 'This helps loosen the tendons around the calf and ankle', 'Switch directions'] 
      },
      { 
        id: 'cl281', 
        name: 'Stretching - Seated Calf Stretch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Calves/Stretching - Seated Calf Stretch.mp4', 
        muscles: ['Calves'], 
        steps: ['Sit on the floor with legs extended', 'Reach forward and pull your toes toward your body', 'Use a towel or strap if needed', 'Hold the stretch and breathe'] 
      },
      { 
        id: 'cl283', 
        name: 'Stretching - Standing Bench Calf Stretch', 
        sets: 2, 
        reps: 30, // seconds
        videoPath: 'Calves/Stretching - Standing Bench Calf Stretch.mp4', 
        muscles: ['Calves', 'Achilles'], 
        steps: ['Place the ball of your foot against the side of a bench or wall', 'Keep your heel on the ground', 'Lean your body forward into the bench', 'Hold for 30 seconds per leg'] 
      }
    ]
  },
  {
    id: 12,
    name: 'Chest Sculpt & Heavy Press',
    exercises_count: 23, // Based on range IDs 304–326 in your database
    premium: true,
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800', 
    exercises: [
      { 
        id: 'ch304', 
        name: 'Barbell Bench Press', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Chest/Barbell Bench Press.mp4', 
        muscles: ['Chest', 'Triceps'], 
        steps: ['Lie on bench with feet flat', 'Grip bar slightly wider than shoulders', 'Lower bar to mid-chest', 'Press upward to full extension'] 
      },
      { 
        id: 'ch309', 
        name: 'Chest Dips', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Chest/Chest Dips.mp4', 
        muscles: ['Lower Chest', 'Triceps'], 
        steps: ['Grip parallel bars and lift yourself', 'Lean your torso forward slightly', 'Lower your body by bending elbows', 'Push back up to the start'] 
      },
      { 
        id: 'ch311', 
        name: 'Deep Push-ups', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Chest/Deep Push-ups.mp4', 
        muscles: ['Chest'], 
        steps: ['Use handles or blocks to increase range', 'Lower your chest below your hands', 'Keep core tight and back flat', 'Push back up explosively'] 
      },
      { 
        id: 'ch316', 
        name: 'Dumbbell Fly', 
        sets: 3, 
        reps: 12, 
        videoPath: 'Chest/Dumbbell Fly.mp4', 
        muscles: ['Chest'], 
        steps: ['Lie on bench with weights above chest', 'Lower arms in a wide arc with slight elbow bend', 'Feel the stretch across your chest', 'Bring weights back together at the top'] 
      },
      { 
        id: 'ch317', 
        name: 'Dumbbell Incline Bench Press', 
        sets: 4, 
        reps: 10, 
        videoPath: 'Chest/Dumbbell Incline Bench Press.mp4', 
        muscles: ['Upper Chest', 'Shoulders'], 
        steps: ['Set bench to 30-45 degrees', 'Press dumbbells from shoulders to ceiling', 'Control the weights on the way down', 'Keep feet planted for stability'] 
      },
      { 
        id: 'ch325', 
        name: 'Lever Pec Deck Fly', 
        sets: 3, 
        reps: 15, 
        videoPath: 'Chest/Lever Pec Deck Fly.mp4', 
        muscles: ['Chest'], 
        steps: ['Sit with back against the pad', 'Grip handles with elbows slightly bent', 'Bring handles together in front of you', 'Squeeze chest hard at the center'] 
      },
      { 
        id: 'ch326', 
        name: 'Push-ups', 
        sets: 3, 
        reps: 20, 
        videoPath: 'Chest/Push-ups.mp4', 
        muscles: ['Chest', 'Triceps'], 
        steps: ['Place hands shoulder-width apart', 'Lower body until chest nearly touches floor', 'Maintain a straight line from head to heels', 'Push back to the start position'] 
      }
    ]
  }

];



{/*
  
  export const WORKOUT_DATA = [
  {
    id: 1,
    name: 'Full Body Workout',
    exercises_count: 7,
    premium: true,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800',
    exercises: [
      { 
        id: 'fb1', 
        name: 'Burpees', 
        sets: 3, 
        reps: 12, 
        muscles: ['Full Body', 'Core'], 
        steps: ['Drop into a squat', 'Kick feet back into plank', 'Perform a pushup', 'Jump feet forward', 'Explode upwards'],
        image: 'https://i.imgur.com/1Q9Z1Zm.png' 
      },
      { id: 'fb2', name: 'Goblet Squats', sets: 4, reps: 10, muscles: ['Quads', 'Glutes'], steps: ['Hold weight at chest', 'Squat deep', 'Keep back straight'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'fb3', name: 'Push Ups', sets: 3, reps: 15, muscles: ['Chest', 'Triceps'], steps: ['Hands shoulder-width', 'Lower chest to floor', 'Push up'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'fb4', name: 'Dumbbell Rows', sets: 3, reps: 12, muscles: ['Lats', 'Biceps'], steps: ['Bend knees slightly', 'Pull weight to hip', 'Squeeze blade'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'fb5', name: 'Lunge Jumps', sets: 3, reps: 20, muscles: ['Quads', 'Hamstrings'], steps: ['Lunge position', 'Jump and switch legs', 'Land softly'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'fb6', name: 'Plank to Pushup', sets: 3, reps: 10, muscles: ['Core', 'Shoulders'], steps: ['Start in plank', 'Move to pushup position one arm at a time'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'fb7', name: 'Kettlebell Swings', sets: 4, reps: 15, muscles: ['Glutes', 'Hamstrings'], steps: ['Hinge at hips', 'Swing bell to eye level', 'Snap hips forward'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 2,
    name: 'Lower Body Workout',
    exercises_count: 7,
    premium: false,
    image: 'https://images.unsplash.com/photo-1434608519344-49d77a699e1d?w=800',
    exercises: [
      { id: 'lb1', name: 'Squats', sets: 4, reps: 12, muscles: ['Quads', 'Glutes'], steps: ['Feet width apart', 'Lower hips', 'Drive through heels'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb2', name: 'Deadlifts', sets: 4, reps: 10, muscles: ['Hamstrings', 'Lower Back'], steps: ['Bar close to shins', 'Lift with flat back', 'Lockout at top'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb3', name: 'Leg Press', sets: 3, reps: 12, muscles: ['Quads', 'Glutes'], steps: ['Place feet on sled', 'Lower slowly', 'Push up, do not lock knees'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb4', name: 'Hamstring Curls', sets: 3, reps: 15, muscles: ['Hamstrings'], steps: ['Lie on bench', 'Curl legs to glutes', 'Control the return'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb5', name: 'Calf Raises', sets: 4, reps: 20, muscles: ['Calves'], steps: ['Stand on edge', 'Raise onto toes', 'Lower below parallel'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb6', name: 'Leg Extensions', sets: 3, reps: 12, muscles: ['Quads'], steps: ['Sit in machine', 'Extend legs fully', 'Squeeze quads'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'lb7', name: 'Glute Bridges', sets: 3, reps: 15, muscles: ['Glutes', 'Core'], steps: ['Lie on back', 'Lifts hips high', 'Squeeze glutes'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 3,
    name: 'Chest Workout',
    exercises_count: 5,
    premium: false,
    image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800',
    exercises: [
      { id: 'ch1', name: 'Incline Bench Press* Dumbbell', sets: 4, reps: 8, muscles: ['Upper Chest', 'Shoulders'], steps: ['Bench at 45 degrees', 'Press dumbbells up', 'Lower slowly'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ch2', name: 'Bench Fly* Dumbbell', sets: 4, reps: 8, muscles: ['Inner Chest'], steps: ['Lie flat', 'Open arms wide', 'Bring weights together'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ch3', name: 'Pullover* Dumbbell', sets: 4, reps: 8, muscles: ['Chest', 'Serratus'], steps: ['Lie across bench', 'Lower weight behind head', 'Pull to chest'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ch4', name: 'Decline Bench Press* Dumbbell', sets: 4, reps: 8, muscles: ['Lower Chest'], steps: ['Lie head-down', 'Press weights up', 'Lower with control'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ch5', name: 'Push Ups (Wide)', sets: 3, reps: 15, muscles: ['Chest', 'Shoulders'], steps: ['Hands wider than usual', 'Lower body', 'Push back up'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 4,
    name: 'Back Workout',
    exercises_count: 5,
    premium: true,
    image: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=800',
    exercises: [
      { id: 'bk1', name: 'Pull Ups', sets: 3, reps: 8, muscles: ['Lats', 'Biceps'], steps: ['Grip bar wide', 'Pull chin above bar', 'Lower slowly'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bk2', name: 'One-Arm Dumbbell Row', sets: 4, reps: 10, muscles: ['Lats', 'Rhomboids'], steps: ['Brace on bench', 'Pull dumbbell to hip', 'Keep back flat'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bk3', name: 'Lat Pulldowns', sets: 4, reps: 12, muscles: ['Lats'], steps: ['Pull bar to upper chest', 'Lean back slightly', 'Squeeze'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bk4', name: 'Bent Over Rows', sets: 4, reps: 10, muscles: ['Mid Back'], steps: ['Hinge at 45 deg', 'Pull bar to navel', 'Lower slowly'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bk5', name: 'Back Extensions', sets: 3, reps: 15, muscles: ['Lower Back'], steps: ['Lock heels in', 'Lower torso', 'Raise to flat position'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 5,
    name: 'Abs Workout',
    exercises_count: 6,
    premium: false,
    image: 'https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?w=800',
    exercises: [
      { id: 'ab1', name: 'Crunches', sets: 3, reps: 20, muscles: ['Upper Abs'], steps: ['Lie on back', 'Lift shoulders only', 'Squeeze core'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ab2', name: 'Leg Raises', sets: 3, reps: 15, muscles: ['Lower Abs'], steps: ['Lie flat', 'Raise legs to 90 deg', 'Lower without touching floor'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ab3', name: 'Russian Twists', sets: 3, reps: 30, muscles: ['Obliques'], steps: ['Sit in V-shape', 'Twist side to side', 'Keep feet off floor'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ab4', name: 'Mountain Climbers', sets: 3, reps: 40, muscles: ['Core', 'Cardio'], steps: ['Plank position', 'Drive knees to chest fast'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ab5', name: 'Bicycle Crunches', sets: 3, reps: 20, muscles: ['Core', 'Obliques'], steps: ['Elbow to opposite knee', 'Pedal legs'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ab6', name: 'Plank Hold', sets: 3, reps: 60, muscles: ['Full Core'], steps: ['Forearms on floor', 'Body in straight line', 'Hold tight'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 6,
    name: 'Upper Body Workout',
    exercises_count: 6,
    premium: false,
    image: 'https://images.unsplash.com/photo-1758521959675-5874879f3977?w=800',
    exercises: [
      { id: 'ub1', name: 'Shoulder Press', sets: 4, reps: 10, muscles: ['Shoulders'], steps: ['Press dumbbells up', 'Don\'t lock elbows', 'Lower to ears'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ub2', name: 'Bicep Curls', sets: 3, reps: 12, muscles: ['Biceps'], steps: ['Keep elbows tucked', 'Curl to shoulders', 'Lower slow'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ub3', name: 'Tricep Dips', sets: 3, reps: 12, muscles: ['Triceps'], steps: ['Grip parallel bars', 'Lower body', 'Push up fully'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ub4', name: 'Chest Press', sets: 4, reps: 10, muscles: ['Chest'], steps: ['Press handles forward', 'Squeeze chest', 'Slow return'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ub5', name: 'Lateral Raises', sets: 3, reps: 15, muscles: ['Side Delts'], steps: ['Raise arms to side', 'Slight elbow bend', 'Parallel to floor'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ub6', name: 'Upright Rows', sets: 3, reps: 12, muscles: ['Traps', 'Shoulders'], steps: ['Pull weights to chin', 'Elbows above wrists'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 7,
    name: 'Butt Workout',
    exercises_count: 6,
    premium: false,
    image: 'https://plus.unsplash.com/premium_photo-1661582170363-0a42b3f5e3cb?w=800',
    exercises: [
      { id: 'bt1', name: 'Glute Bridges', sets: 4, reps: 15, muscles: ['Glutes'], steps: ['Lifts hips', 'Squeeze at top', 'Lower slowly'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bt2', name: 'Donkey Kicks', sets: 3, reps: 20, muscles: ['Glutes'], steps: ['On all fours', 'Kick heel to ceiling', 'Don\'t arch back'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bt3', name: 'Sumo Squats', sets: 4, reps: 12, muscles: ['Glutes', 'Inner Thigh'], steps: ['Wide stance', 'Toes out', 'Squat deep'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bt4', name: 'Fire Hydrants', sets: 3, reps: 20, muscles: ['Outer Glutes'], steps: ['On all fours', 'Lift leg to the side', 'Keep hip square'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bt5', name: 'Bulgarian Split Squat', sets: 3, reps: 10, muscles: ['Glutes', 'Quads'], steps: ['One foot on bench', 'Squat with lead leg', 'Chest up'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'bt6', name: 'Walking Lunges', sets: 3, reps: 20, muscles: ['Glutes', 'Legs'], steps: ['Step forward', 'Both knees 90 deg', 'Alternate steps'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 8,
    name: 'Arm Workout',
    exercises_count: 7,
    premium: true,
    image: 'https://plus.unsplash.com/premium_photo-1661265933107-85a5dbd815af?w=800',
    exercises: [
      { id: 'ar1', name: 'Hammer Curls', sets: 3, reps: 12, muscles: ['Brachialis', 'Biceps'], steps: ['Palms face in', 'Curl to shoulder', 'Squeeze'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar2', name: 'Skull Crushers', sets: 3, reps: 10, muscles: ['Triceps'], steps: ['Lie flat', 'Lower bar to forehead', 'Extend arms'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar3', name: 'Concentration Curls', sets: 3, reps: 12, muscles: ['Bicep Peak'], steps: ['Sit down', 'Elbow on inner thigh', 'Curl weight'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar4', name: 'Overhead Tricep Extension', sets: 3, reps: 12, muscles: ['Triceps'], steps: ['Weight overhead', 'Lower behind neck', 'Press up'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar5', name: 'Spider Curls', sets: 3, reps: 10, muscles: ['Biceps'], steps: ['Chest on incline bench', 'Let arms hang', 'Curl up'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar6', name: 'Tricep Kickbacks', sets: 3, reps: 15, muscles: ['Triceps'], steps: ['Hinge at hips', 'Extend arm back', 'Squeeze tricep'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'ar7', name: 'Wrist Curls', sets: 3, reps: 20, muscles: ['Forearms'], steps: ['Forearms on bench', 'Curl wrists up', 'Slowly lower'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 9,
    name: 'Shoulder Workout',
    exercises_count: 5,
    premium: false,
    image: 'https://images.unsplash.com/photo-1532029837206-abbe2b7620e3?w=800',
    exercises: [
      { id: 'sh1', name: 'Military Press', sets: 4, reps: 8, muscles: ['Front Delts'], steps: ['Stand tall', 'Press bar from chest', 'Lock out top'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'sh2', name: 'Front Raises', sets: 3, reps: 12, muscles: ['Front Delts'], steps: ['Raise arms forward', 'Parallel to floor', 'Lower slow'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'sh3', name: 'Rear Delt Flys', sets: 3, reps: 15, muscles: ['Rear Delts'], steps: ['Bent over position', 'Fly weights to sides', 'Squeeze blades'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'sh4', name: 'Arnold Press', sets: 3, reps: 10, muscles: ['Shoulders'], steps: ['Start with palms in', 'Rotate as you press', 'Palms out at top'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'sh5', name: 'Shrugs', sets: 4, reps: 12, muscles: ['Traps'], steps: ['Hold dumbbells', 'Raise shoulders to ears', 'Hold and lower'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  },
  {
    id: 10,
    name: 'V-taper workout',
    exercises_count: 6,
    premium: false,
    image: 'https://images.unsplash.com/photo-1605296867304-46d5465a13f1?w=800',
    exercises: [
      { id: 'vt1', name: 'Wide Grip Pullups', sets: 4, reps: 8, muscles: ['Upper Lats'], steps: ['Extra wide grip', 'Pull chest to bar', 'Full stretch down'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'vt2', name: 'Lat Pulldowns', sets: 4, reps: 12, muscles: ['Lats'], steps: ['Pull to collarbone', 'Arch back slightly', 'Slow release'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'vt3', name: 'Lateral Raises', sets: 4, reps: 15, muscles: ['Side Delts'], steps: ['Dumbbells to side', 'Lead with elbows', 'Shoulder height'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'vt4', name: 'Face Pulls', sets: 3, reps: 15, muscles: ['Rear Delts', 'Traps'], steps: ['Pull rope to forehead', 'Pull ends apart', 'Squeeze back'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'vt5', name: 'Dumbbell Pullovers', sets: 3, reps: 12, muscles: ['Lats', 'Chest'], steps: ['Upper back on bench', 'Lower weight back', 'Pull over chest'], image: 'https://i.imgur.com/1Q9Z1Zm.png' },
      { id: 'vt6', name: 'Straight Arm Pulldowns', sets: 3, reps: 12, muscles: ['Lats'], steps: ['Keep arms straight', 'Push bar to thighs', 'Control the rise'], image: 'https://i.imgur.com/1Q9Z1Zm.png' }
    ]
  }
];
  
  
  
 

  {
    id: 1,
    name: 'Full Body Workout',
    exercises_count: 4,
    premium: true,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800',
    exercises: [
      { id: 'fb1', name: 'Burpee', sets: 3, reps: 12, videoPath: 'Cardio/Burpee.mp4', muscles: ['Full Body'], steps: ['Drop to squat', 'Kick back', 'Push up', 'Jump up'] },
      { id: 'fb2', name: 'Push-ups', sets: 4, reps: 10, videoPath: 'Chest/Push-ups.mp4', muscles: ['Chest', 'Triceps'], steps: ['Hands shoulder-width', 'Lower chest', 'Push up'] },
      { id: 'fb3', name: 'Barbell Curl', sets: 3, reps: 15, videoPath: 'biceps/Barbell Curl.mp4', muscles: ['Biceps'], steps: ['Hold bar', 'Curl up', 'Slowly lower'] },
      { id: 'fb4', name: 'Arnold Press', sets: 3, reps: 12, videoPath: 'Shoulders/Dumbbell Arnold Press.mp4', muscles: ['Shoulders'], steps: ['Dumbbells at chin', 'Rotate as you press', 'Full extension'] },
    ]
  },

*/}